import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/navigation',
      name: 'navigation',
      component: () => import('@/views/navigation'),
      hidden: true,
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login'),
      hidden: true,
    },
    {
      path: '/',
      redirect: '/home/index',
      component: Layout,
      hidden: true,
    },
    {
      path: '/home',
      redirect: '/home/index',
      component: Layout,
      meta: { title: '综合监视', icon: 'icon-zonghe', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'Home',
          component: () => import('@/views/home'),
          meta: { title: '综合监视', requireAuth: true },
          hidden: true,
        },
      ],
    },

    {
      path: '/user',
      redirect: '/user/index',
      component: Layout,
      meta: { title: '用户管理', icon: 'icon-users', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'User',
          component: () => import('@/views/user'),
          meta: { title: '用户管理', requireAuth: true, keepAlive: true },
          hidden: true,
        },
        {
          path: 'detail',
          name: 'UserDetail',
          component: () => import('@/views/user/detail'),
          meta: { title: '用户详情', requireAuth: true },
          hidden: true,
        },
        {
          path: 'addeditcompany',
          name: 'addEditCompany',
          component: () => import('@/views/user/addeditcompany'),
          meta: { title: '新增编辑公司账号', requireAuth: true },
          hidden: true,
        },
        {
          path: 'addeditdept',
          name: 'addEditDept',
          component: () => import('@/views/user/addeditdept'),
          meta: { title: '新增编辑部门账号', requireAuth: true },
          hidden: true,
        },
        {
          path: 'personal',
          name: 'UserPersonal',
          component: () => import('@/views/user/personal'),
          meta: { title: '个人信息', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/car',
      redirect: '/car/index',
      component: Layout,
      meta: { title: '车辆管理', icon: 'icon-cheliang', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'Car',
          component: () => import('@/views/car'),
          meta: { title: '车辆管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'detail',
          name: 'CarDetail',
          component: () => import('@/views/car/detail'),
          meta: { title: '车辆管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'add',
          name: 'add',
          component: () => import('@/views/car/add'),
          meta: { title: '车辆管理', requireAuth: true },
          hidden: true,
        },
      ],
    },

    {
      path: '/rentcar',
      redirect: '/rentcar/index',
      component: Layout,
      meta: { title: '租车', icon: 'icon-zonghe', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'rentcar',
          component: () => import('@/views/rentCar'),
          meta: { title: '租车', requireAuth: true },
          hidden: true,
        },
      ],
    },

    {
      path: '/returncar',
      redirect: '/returncar/index',
      component: Layout,
      meta: { title: '还车', icon: 'icon-zonghe', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'rentcar',
          component: () => import('@/views/returnCar'),
          meta: { title: '还车', requireAuth: true },
          hidden: true,
        },
      ],
    },

    {
      path: '/renewal',
      redirect: '/renewal/index',
      component: Layout,
      meta: { title: '续租', icon: 'icon-zonghe', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'rentcar',
          component: () => import('@/views/renewal'),
          meta: { title: '续租', requireAuth: true },
          hidden: true,
        },
      ],
    },

    {
      path: '/api',
      redirect: '/api/index',
      component: Layout,
      meta: {
        title: 'API接口管理',
        icon: 'icon-jiekouzhongxin',
        requireAuth: true,
      },
      children: [
        {
          path: 'index',
          name: 'Api',
          component: () => import('@/views/api'),
          meta: { title: 'API接口管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'detail',
          name: 'ApiDetail',
          component: () => import('@/views/api/detail'),
          meta: { title: 'API接口管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'add',
          name: 'add',
          component: () => import('@/views/api/add'),
          meta: { title: 'API接口管理', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/company',
      redirect: '/company/index',
      component: Layout,
      meta: { title: '公司管理', icon: 'icon-zonghe', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'company',
          component: () => import('@/views/company'),
          meta: { title: '公司管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'add',
          name: 'company',
          component: () => import('@/views/company/add'),
          meta: { title: '新增', requireAuth: true },
          hidden: true,
        },
        {
          path: 'edit',
          name: 'editComp',
          component: () => import('@/views/company/edit'),
          meta: { title: '编辑', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/tbox',
      redirect: '/tbox/index',
      component: Layout,
      meta: {
        title: 'TBOX管理',
        icon: 'icon-jiekouzhongxin',
        requireAuth: true,
      },
      children: [
        {
          path: 'index',
          name: 'Tbox',
          component: () => import('@/views/tbox'),
          meta: { title: 'TBOX管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'edit',
          name: 'edit',
          component: () => import('@/views/tbox/edit'),
          meta: { title: 'TBOX管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'add',
          name: 'add',
          component: () => import('@/views/tbox/add'),
          meta: { title: 'TBOX管理', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/tboxUpgrade',
      redirect: '/tboxUpgrade/index',
      component: Layout,
      meta: {
        title: 'TBOX版本升级',
        icon: 'icon-jiekouzhongxin',
        requireAuth: true,
      },
      children: [
        {
          path: 'index',
          name: 'tboxUpgrade',
          component: () => import('@/views/tboxUpgrade'),
          meta: { title: 'TBOX管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'add',
          name: 'tboxUpgradeAdd',
          component: () => import('@/views/tboxUpgrade/add'),
          meta: { title: 'TBOX管理', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/alarm',
      redirect: '/alarm/index',
      component: Layout,
      meta: {
        title: '报警信息管理',
        icon: 'icon-icon-alarm',
        requireAuth: true,
      },
      children: [
        {
          path: 'index',
          name: 'alarm',
          component: () => import('@/views/alarm'),
          meta: { title: '报警信息管理', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/lease',
      redirect: '/lease/index',
      component: Layout,
      meta: {
        title: '租赁信息管理',
        icon: 'icon-icon-alarm',
        requireAuth: true,
      },
      children: [
        {
          path: 'index',
          name: 'Lease',
          component: () => import('@/views/lease'),
          meta: { title: '租赁信息管理', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/system',
      redirect: '/system/index',
      component: Layout,
      meta: { title: '系统信息维护', icon: 'icon-weixiu', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'System',
          component: () => import('@/views/system'),
          meta: { title: '系统信息维护', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/data',
      redirect: '/data/index',
      component: Layout,
      meta: { title: '数据分析', icon: 'icon-shuju', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'Data',
          meta: { title: '数据分析', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/log',
      redirect: '/log/index',
      component: Layout,
      meta: { title: '日志管理', icon: 'icon-rizhi', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'Log',
          component: () => import('@/views/log'),
          meta: { title: '日志管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'detail',
          name: 'detail',
          component: () => import('@/views/log/detail'),
          meta: { title: '日志管理', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/authority',
      redirect: '/authority/index',
      component: Layout,
      meta: {
        title: '权限管理',
        icon: 'icon-jiekouzhongxin',
        requireAuth: true,
      },
      children: [
        {
          path: 'index',
          name: 'Authority',
          component: () => import('@/views/authority'),
          meta: { title: '权限管理', requireAuth: true, keepAlive: true },
          hidden: true,
        },
        {
          path: 'setauth',
          name: 'SetAuth',
          component: () => import('@/views/authority/set'),
          meta: { title: '设置权限', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/maintain',
      redirect: '/maintain/index',
      component: Layout,
      meta: {
        title: '维护记录',
        icon: 'icon-jiekouzhongxin',
        requireAuth: true,
      },
      children: [
        {
          path: 'index',
          name: 'Maintain',
          component: () => import('@/views/maintain'),
          meta: { title: '维护记录', requireAuth: true },
          hidden: true,
        },
        {
          path: 'status',
          name: 'Status',
          component: () => import('@/views/maintain/status'),
          meta: { title: '维护记录状态', requireAuth: true },
          hidden: true,
        },
        {
          path: 'addeditmaintain',
          name: 'addEditMaintain',
          component: () => import('@/views/maintain/addeditmaintain'),
          meta: { title: '维护记录新增修改', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/feedback',
      redirect: '/feedback/index',
      component: Layout,
      meta: { title: '用户反馈', icon: 'icon-cheliang', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'Feedback',
          component: () => import('@/views/feedback'),
          meta: { title: '用户反馈', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/serviceType',
      redirect: '/serviceType/index',
      component: Layout,
      meta: { title: '服务类型管理', icon: 'icon-cheliang', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'serviceType',
          component: () => import('@/views/serviceType'),
          meta: { title: '服务类型管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'addServiceType',
          name: 'addServiceType',
          component: () => import('@/views/serviceType/add'),
          meta: { title: '服务类型新增', requireAuth: true },
          hidden: true,
        },
        {
          path: 'editServiceType',
          name: 'editServiceType',
          component: () => import('@/views/serviceType/edit'),
          meta: { title: '服务类型详情', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/hardware',
      redirect: '/hardware/index',
      component: Layout,
      meta: { title: '硬件管理', icon: 'icon-cheliang', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'hardware',
          component: () => import('@/views/hardware'),
          meta: { title: '服务类型管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'addHardware',
          name: 'addHardware',
          component: () => import('@/views/hardware/add'),
          meta: { title: '服务类型新增', requireAuth: true },
          hidden: true,
        },
        {
          path: 'editHardware',
          name: 'editHardware',
          component: () => import('@/views/hardware/edit'),
          meta: { title: '服务类型详情', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/customer',
      redirect: '/customer/index',
      component: Layout,
      meta: { title: '顾客管理', icon: 'icon-cheliang', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'customer',
          component: () => import('@/views/customer'),
          meta: { title: '顾客管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'addCustomer',
          name: 'addCustomer',
          component: () => import('@/views/customer/add'),
          meta: { title: '顾客管理', requireAuth: true },
          hidden: true,
        },
      ],
    },
    {
      path: '/order',
      redirect: '/order/index',
      component: Layout,
      meta: { title: '订单管理', icon: 'icon-cheliang', requireAuth: true },
      children: [
        {
          path: 'index',
          name: 'order',
          component: () => import('@/views/order'),
          meta: { title: '订单管理', requireAuth: true },
          hidden: true,
        },
        {
          path: 'addOrder',
          name: 'addOrder',
          component: () => import('@/views/order/add'),
          meta: { title: '订单管理', requireAuth: true },
          hidden: true,
        },
      ],
    },
  ],
});
